import ButtonGroup from "@legacy/core/buttons/ButtonGroup"
import ButtonGroupRow from "@legacy/core/buttons/ButtonGroupRow"
import UniversalButton from "@legacy/core/buttons/UniversalButton"
import Spinner from "@legacy/core/components/Spinner"
import BasicDisplayField from "@legacy/core/fields/BasicDisplayField"
import { Component, Fragment } from "react"

import { formatLocalTime } from "../../core/utils/utils"

class ClientBalanceHistoryForm extends Component {
    constructor(props) {
        super(props)

        this.addToastToQueue = this.props.addToastToQueue

        this.state = {
            transactionsData: null,
            errors: {
                transactionsDataErrors: null,
            },
        }
    }

    componentDidMount = async () => {
        if (this.state.transactionsData === null) {
            const initialEndpoint = DjangoUrls["clients:api-clients-balance-transactions-list"](
                window.MARKETPLACE_ENTITY_SLUG,
                this.props.client.id,
            )

            try {
                const transactions = []
                let responseJSON = { next: initialEndpoint, results: [] }

                while (responseJSON.next !== null) {
                    const response = await fetch(responseJSON.next)
                    responseJSON = await response.json()
                    transactions.push(...responseJSON.results)
                }

                this.setState((state) => {
                    return { ...state, transactionsData: transactions }
                })
            } catch (error) {
                this.setState((state) => {
                    return {
                        ...state,
                        transactionsData: [],
                        errors: { transactionsDataErrors: error },
                    }
                })
            }
        }
    }

    renderTransactionRow = (transaction) => {
        const { formatCurrencyValue } = this.props
        const isCredit = transaction.transaction_type === "credit"
        const typePrefix = isCredit ? "+" : "-"
        const { localDateTimeString } = formatLocalTime(
            transaction.created_at,
            window.PREFERRED_TIMEZONE,
            false,
            true,
            false,
            true,
        )

        return (
            <div key={transaction.id} className="data-panel__form__field" aria-label="Balance Transaction">
                <div className="data-panel__form__field__label">{localDateTimeString}</div>
                <div className="data-panel__form__field__value">
                    <span style={{ fontWeight: "500", color: isCredit ? "var(--jade-9)" : "var(--tomato-9)" }}>
                        {typePrefix}{formatCurrencyValue(transaction.amount)}
                    </span>
                    <br />
                    <span dangerouslySetInnerHTML={{ __html: transaction.description }} />
                </div>
            </div>
        )
    }

    render = () => {
        const { client, formatCurrencyValue } = this.props

        if (this.state.transactionsData === null) {
            return <Spinner centered={true} />
        }

        return (
            <div className="data-panel-container data-panel-container--with-margin">
                <div className="data-panel" aria-label="Balance History">
                    <div className="data-panel__form" aria-label="Balance History">
                        <Fragment>
                            <BasicDisplayField
                                fieldName="current_balance"
                                fieldLabel="Current Balance"
                                fieldValue={client.credit_balance ? formatCurrencyValue(client.credit_balance) : "?"}
                            />
                            <div className="section-separator">Transaction History</div>
                            <div
                                className="data-panel__form__field"
                                id="div_id_transaction_errors"
                                aria-label="Transaction Errors"
                                style={
                                    this.state.errors.transactionsDataErrors
                                        ? { display: "initial" }
                                        : { display: "none" }
                                }
                            >
                                {this.state.errors.transactionsDataErrors && (
                                    <div
                                        className="data-panel__form__field__errors text-centered"
                                        aria-label="Field Errors"
                                    >
                                        There was an issue loading balance transactions. Try coming back to this page
                                        and trying again in a bit.
                                    </div>
                                )}
                            </div>
                            {this.state.transactionsData.length === 0 && (
                                <p className="data-panel__form__caption">No balance transactions found.</p>
                            )}
                            {this.state.transactionsData.map((transaction) =>
                                this.renderTransactionRow(transaction)
                            )}
                        </Fragment>
                    </div>
                    <ButtonGroup>
                        <ButtonGroupRow>
                            <UniversalButton
                                type="secondary"
                                text="Return to Client"
                                handler={(event) => this.props.switchToPrimaryForm()}
                            />
                        </ButtonGroupRow>
                    </ButtonGroup>
                </div>
            </div>
        )
    }
}

export default ClientBalanceHistoryForm
